import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ExamTemplateDelete.css';
const cx = classNames.bind(styles);

class ExamTemplateDelete extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { deleting, templateInfo, removeTemplate, handleOnToggleDeleteModal } = this.props;
    const { templateNo, serviceTemplateNo, templateName, serviceNo, regEpoch } = templateInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleDeleteModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'ExamTemplateDelete_1', defaultMessage: '훈련 양식(템플릿) 삭제' }))}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleDeleteModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateDelete_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={deleting} disabled={deleting} onClick={removeTemplate}>
              {defineMessages(formatMessage({ id: 'ExamTemplateDelete_3', defaultMessage: '삭 제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={deleting}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateDelete_5',
              defaultMessage: '삭제한 템플릿은 복구할 수 없습니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ExamTemplateDelete_9',
              defaultMessage: '다음 템플릿을 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          {/* <Message.Header>
            {defineMessages(
              formatMessage({
                id: 'ExamTemplateDelete_5',
                defaultMessage: '삭제한 템플릿은 복구할 수 없습니다. 다음 템플릿을 삭제합니까?'
              })
            )}
          </Message.Header> */}
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {serviceTemplateNo
                  ? serviceTemplateNo
                  : templateNo +
                    ' ' +
                    defineMessages(formatMessage({ id: 'ExamTemplateDelete_6', defaultMessage: '(기본 제공)' }))}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateDelete_7', defaultMessage: '템플릿명' }))}
                </div>
                {templateName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateDelete_8', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

ExamTemplateDelete.propTypes = {
  //
};
ExamTemplateDelete.defaultProps = {
  //
};

export default injectIntl(ExamTemplateDelete);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateDelete.js